export default __webpack_public_path__ + "static/media/bg-3.142bf5c0.jpg";